var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{scopedSlots:_vm._u([{key:"end",fn:function(){return undefined},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }